import { render, staticRenderFns } from "./bindProcess.vue?vue&type=template&id=4c3524b9&scoped=true"
import script from "./bindProcess.vue?vue&type=script&lang=js"
export * from "./bindProcess.vue?vue&type=script&lang=js"
import style0 from "./bindProcess.vue?vue&type=style&index=0&id=4c3524b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3524b9",
  null
  
)

export default component.exports